<template>
  <div style="flex: 1 1 0px">
    <v-dialog
      v-model="dialog"
      :width="720"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="stat-card" v-on="on" v-bind="attrs">
          <div class="stat-card__top">
            <div class="stat-card__number">
              <v-progress-circular
                v-if="loading"
                indeterminate
                size="24"
                width="2"
                color="accent"
              ></v-progress-circular>
              <span v-else>{{ clients.length }}</span>
            </div>
            <div class="stat-card__icon">
              <hero-icon :icon="UsersIcon" :size="20" />
            </div>
          </div>
          <div class="stat-card__label">Clientes asignados</div>
        </div>
      </template>

      <v-card class="cl-card rounded-lg">
        <div class="cl-dialog__head">
          <div class="cl-dialog__head-text">
            <div class="cl-dialog__title">Clientes</div>
            <div class="cl-dialog__sub">
              <template v-if="loading">Cargando…</template>
              <template v-else>{{ clients.length }} asignados</template>
            </div>
          </div>
          <button type="button" class="cl-ghost-btn" @click="dialog = false">
            <hero-icon :icon="XMarkIcon" :size="18" />
          </button>
        </div>

        <div class="cl-divider"></div>

        <div class="cl-dialog__body">
          <div v-if="loading" class="cl-loading">
            <v-progress-circular
              indeterminate
              size="28"
              width="2"
              color="accent"
            ></v-progress-circular>
          </div>

          <div v-else-if="!clients.length" class="cl-empty">
            Sin clientes asignados
          </div>

          <template v-else>
            <router-link
              v-for="contact in clients"
              :key="contact.id"
              :to="{ name: 'admin_user_detail', params: { id: contact.id } }"
              class="cl-row"
            >
              <div class="cl-row__avatar">
                {{ initial(contact) }}
              </div>
              <div class="cl-row__body">
                <div class="cl-row__name">{{ contact.profile.name }}</div>
                <div class="cl-row__details">
                  <div v-if="contact.profile.email" class="cl-row__detail">
                    <hero-icon :icon="EnvelopeIcon" :size="14" />
                    <span>{{ contact.profile.email }}</span>
                  </div>
                  <div v-if="contact.profile.phone" class="cl-row__detail">
                    <hero-icon :icon="PhoneIcon" :size="14" />
                    <span>{{ contact.profile.phone }}</span>
                  </div>
                  <div v-if="contact.profile.address" class="cl-row__detail">
                    <hero-icon :icon="MapPinIcon" :size="14" />
                    <span>{{ contact.profile.address }}</span>
                  </div>
                </div>
              </div>
            </router-link>
          </template>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Clients } from "@/graphql/queries/staff";
import HeroIcon from "@/components/shared/HeroIcon.vue";
import UsersIcon from "heroicons/24/outline/users.svg";
import XMarkIcon from "heroicons/24/outline/x-mark.svg";
import EnvelopeIcon from "heroicons/24/outline/envelope.svg";
import PhoneIcon from "heroicons/24/outline/phone.svg";
import MapPinIcon from "heroicons/24/outline/map-pin.svg";

export default {
  components: { HeroIcon },

  data: () => ({
    dialog: false,
    clients: [],
    loading: false,
    loaded: false,
    UsersIcon,
    XMarkIcon,
    EnvelopeIcon,
    PhoneIcon,
    MapPinIcon
  }),

  props: {
    id: {
      required: true,
      type: Number | String
    }
  },

  created() {
    this.fetchClients();
  },

  watch: {
    id() {
      this.fetchClients();
    }
  },

  methods: {
    initial(contact) {
      const name =
        contact && contact.profile && contact.profile.name
          ? contact.profile.name.trim()
          : "";
      return name ? name.charAt(0).toUpperCase() : "?";
    },

    fetchClients() {
      this.loading = true;

      this.$apollo
        .query({
          query: Clients,
          fetchPolicy: "cache-first",
          variables: {
            id: this.id
          }
        })
        .then(res => {
          this.clients = res.data.clients.contacts;
          this.loaded = true;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
/* ===== Canonical Gestiones stat card (shared across all four analytics cards) ===== */
.stat-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  height: 100%;
  padding: 18px;
  background: #ffffff;
  border: 1px solid #ece7de;
  border-radius: 12px;
  box-shadow: 0 8px 24px -16px rgba(40, 33, 22, 0.18);
  cursor: pointer;
  transition: border-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}

.stat-card:hover {
  border-color: #dcd4c6;
  box-shadow: 0 12px 28px -16px rgba(40, 33, 22, 0.24);
  transform: translateY(-1px);
}

.stat-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.stat-card__number {
  display: flex;
  align-items: center;
  min-height: 30px;
  font-size: 30px;
  font-weight: 700;
  line-height: 1;
  color: #1a1814;
}

.stat-card__icon {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #faf8f4;
  color: #b52118;
}

.stat-card__label {
  font-size: 13.5px;
  color: #756f64;
}

/* ---- Dialog chrome ---- */
.cl-card {
  background: #ffffff;
}

.cl-dialog__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 20px 14px;
}

.cl-dialog__title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1814;
  line-height: 1.2;
}

.cl-dialog__sub {
  font-size: 13px;
  color: #756f64;
  margin-top: 2px;
}

.cl-ghost-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  color: #756f64;
  background: transparent;
  transition: background 0.16s ease, color 0.16s ease;
}

.cl-ghost-btn:hover {
  background: #f1ece3;
  color: #1a1814;
}

.cl-divider {
  height: 1px;
  background: #ece7de;
}

.cl-dialog__body {
  padding: 16px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cl-loading {
  display: flex;
  justify-content: center;
  padding: 32px 0;
}

.cl-empty {
  text-align: center;
  color: #a39a8c;
  font-size: 14px;
  padding: 36px 0;
}

/* ---- Card-rows ---- */
.cl-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 16px;
  border: 1px solid #ece7de;
  border-radius: 12px;
  text-decoration: none;
  transition: border-color 0.16s ease, box-shadow 0.16s ease,
    transform 0.16s ease;
}

.cl-row:hover {
  border-color: #dcd4c6;
  box-shadow: 0 8px 24px -16px rgba(40, 33, 22, 0.18);
  transform: translateY(-1px);
}

.cl-row__avatar {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #1a1814;
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
}

.cl-row__body {
  flex: 1 1 auto;
  min-width: 0;
}

.cl-row__name {
  font-size: 14.5px;
  font-weight: 600;
  color: #1a1814;
}

.cl-row__details {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cl-row__detail {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #756f64;
  min-width: 0;
}

.cl-row__detail >>> .hero-icon {
  color: #a39a8c;
}

.cl-row__detail span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
